import { observable, makeObservable } from 'mobx';
import { createModelSchema, primitive } from 'serializr';

import { optional } from '@vromo/models';

export class KeyValue {
    id: number | null = null;

    subject: number | null = null;
    key: string | null = null;
    value: string | null = null;

    constructor(init?: Partial<KeyValue>) {
        makeObservable(this, {
            subject: observable,
            key: observable,
            value: observable
        });
        Object.assign(this, init);
    }
}

createModelSchema(KeyValue, {
    id: optional(primitive()),
    subject: optional(primitive()),
    key: optional(primitive()),
    value: optional(primitive())
});
